import { addSeconds, getSeconds } from 'date-fns'
import { ILicense } from '../../models/License'
import { calculateDays } from './getDays'

const getFinalValidLicenses = (
  validLicenses: ILicense[],
): { active: ILicense[]; awaits: ILicense[] } => {
  // const newLicenses = validLicenses.filter(e => e.licenseType > 9)
  // if (newLicenses.length > 0) {
  //   return newLicenses
  // } NIE WIEM CO TO BYŁO ANI PO CO
  // JUŻ WIEM CO TO I PO CO TO BYŁO XDDDDDDDDDD

  return splitLicences(validLicenses)
}

function splitLicences(licences: ILicense[]) {

  const newLicenses = licences
    .filter(e => e.active === 1)

  const awaitsLicenses = licences
    .filter(e => e.active === 0)


  return {
    active: newLicenses.sort(getDays),
    awaits: awaitsLicenses,
  }
}

function getDays(a, b) {
  const diffa = calculateDays(
    getSeconds(a.startTime) === 59 ? addSeconds(a.rawEnd, -1) : a.rawEnd,
  )
  const diffb = calculateDays(
    getSeconds(b.startTime) === 59 ? addSeconds(b.rawEnd, -1) : b.rawEnd,
  )
  return diffa - diffb
}

export default getFinalValidLicenses
